module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-group"
  }, [(_vm.label) ? _c('span', {
    staticClass: "filter-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(opt) {
    return _c('span', {
      key: String(opt.value),
      staticClass: "filter-pill",
      class: {
        'is-on': _vm.isOn(opt.value)
      },
      on: {
        "click": function($event) {
          return _vm.pick(opt.value)
        }
      }
    }, [_c('i', {
      staticClass: "pill-dot",
      style: (opt.color ? {
        background: opt.color
      } : null)
    }), _vm._v(_vm._s(opt.label) + "\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5031df50","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/parts/FilterPills.vue
// module id = 1792
// module chunks = 8